import { createReducer } from "../ReduxHelpers";
import { tryParseJson } from "../../helpers/StringHelpers";
import * as GLOBAL_CONSTANTS from "../../constants/GlobalConstants";
import { act } from "react";

const modelrunInitialState = {
  selectedModelRun: {},
  selectedModelRunId: -1,
  activeModelRunId: -1,
  modelRuns: [],
  nextToken: '',
  tasks: [],
  tasksNextToken: '',
  assets: [],
  assetsNextToken: '',
  // Report runs - unified structure for reporting
  reportRuns: {}, // Structure: { modelRunId: { id, name, status, assets, selectedVtszAssets, selectedMediaAssets } }
  fetchReportAssetsInProgress: false,
  fetchReportAssetsError: false,
  fetchReportAssetsErrorMessage: "",
  loading: false,
  error: false,
  uploadProgress: {},
  cancelTokens: {},
  completedUploads: [],
  fetchInProgress: false,
  fetchError: false,
  fetchErrorMessage: '',
  createInProgress: false,
  createSuccess: false,
  createError: false,
  createErrorMessage: '',
  updateInProgress: false,
  updateError: false,
  updateErrorMessage: '',
  deleteAssetInProgress: false,
  deleteError: false,
  deleteErrorMessage: '',
  deleteAssetStatus: GLOBAL_CONSTANTS.REQUEST_STATUS.NONE,
  deleteModelRunStatus: GLOBAL_CONSTANTS.REQUEST_STATUS.NONE,
  generateInProgress: false,
  generateError: false,
  generateErrorMessage: '',
  executeInProgress: false,
  executeError: false,
  executeErrorMessage: '',
  fetchModelRunTasksInProgress: false,
  fetchModelRunTasksError: false,
  fetchModelRunTasksErrorMessage: '',
  fetchModelRunAssetsInProgress: false,
  fetchModelRunAssetsError: false,
  fetchModelRunAssetsErrorMessage: '',
  executePostProcessingInProgress: false,
  executePostProcessingError: false,
  executePostProcessingErrorMessage: "",
  executePostProcessOverview:{
    logs:[],
    status:'',
    result:'',
    compeletedSteps:[]
  }
};
function resetModelRunState(state, action) {
  return {
    ...state,
    activeModelRunId: -1,
    selectedModelRun: {},
    modelRuns: [],
    tasks: [],
    tasksNextToken: "",
    loading: false,
    uploadProgress: {},
    error: false,
  };
}

function setselectedModelRun(state, action) {
  let newState = { ...state };
  newState.selectedModelRun = { ...action.payload };
  newState.selectedModelRunId = action.payload.id;
  newState.activeModelRunId = action.payload.id;
  newState.selectedModelRun.isDirty = false;
  newState.selectedModelRun.generateRunStatus =
    GLOBAL_CONSTANTS.REQUEST_STATUS.NONE;
  return newState;
}

function fetchModelRunsBegin(state, action) {
  let newState = { ...state };
  newState.fetchInProgress = true;
  newState.fetchError = false;
  newState.fetchErrorMessage = "";
  return newState;
}

function fetchModelRunsSuccess(state, action) {
  let newState = { ...state };
  newState.modelRuns = [...action.payload.listModelRuns.items];
  newState.nextToken = action.payload.listModelRuns.nextToken;
  newState.fetchInProgress = false;
  return newState;
}

function fetchModelRunsFailure(state, action) {
  let newState = { ...state };
  newState.fetchInProgress = false;
  newState.fetchError = true;
  newState.fetchErrorMessage = action.payload;
  return newState;
}

function fetchModelRunByIdBegin(state, action) {
  let newState = { ...state };
  newState.selectedModelRun = {};
  newState.selectedModelRunId = -1;
  newState.fetchInProgress = true;
  newState.fetchError = false;
  newState.fetchErrorMessage = "";
  return newState;
}

function fetchModelRunByIdSuccess(state, action) {
  let newState = { ...state };
  newState.selectedModelRun = { 
    ...action.payload.getModelRun,
    assets: action.payload.getModelRun?.assets?.items || [],
  };
  newState.selectedModelRunId = action.payload.getModelRun?.id;
  newState.fetchInProgress = false;
  return newState;
}
function fetchModelRunByIdFailure(state, action) {
  let newState = { ...state };
  newState.selectedModelRun = {};
  newState.fetchInProgress = false;
  newState.fetchError = true;
  newState.fetchErrorMessage = action.payload;
  return newState;
}
function createNewModelRunBegin(state, action) {
  let newState = { ...state };
  newState.createInProgress = true;
  newState.createSuccess = false;
  return newState;
}
function createNewModelRunSuccess(state, action) {
  let newState = { ...state };
  newState.selectedModelRun = { ...action.payload.createModelRun };
  newState.activeModelRunId = action.payload.createModelRun.id;
  newState.createInProgress = false;
  newState.createSuccess = true;
  return newState;
}

function createNewModelRunFailure(state, action) {
  let newState = { ...state };
  newState.createInProgress = false;
  newState.createError = true;
  newState.activeModelRunId = null;
  newState.createErrorMessage = action.payload;
  newState.createSuccess = false;
  return newState;
}

function updateselectedModelRun(state, action) {
  let newState = { ...state };
  Object.assign(newState.selectedModelRun, action.payload.modelrun);
  newState.selectedModelRun.isDirty = true;
  return newState;
}

function updateModelRunBegin(state, action) {
  let newState = { ...state };
  newState.updateInProgress = true;
  return newState;
}

function updateModelRunSuccess(state, action) {
  let newState = { ...state };
  let { assets } = newState.selectedModelRun;
  newState.selectedModelRun = { ...action.payload.updateModelRun };
  newState.selectedModelRun.assets = { ...assets };
  newState.updateInProgress = false;
  newState.selectedModelRun.isDirty = false;
  return newState;
}

function updateModelRunPropsSuccess(state, action) {
  let newState = { ...state };
  newState.selectedModelRun["runName"] = action.payload.updateModelRun?.runName;
  newState.selectedModelRun["runStatus"] =
    action.payload.updateModelRun?.runStatus;
  newState.updateInProgress = false;
  return newState;
}

function updateModelRunFailure(state, action) {
  let newState = { ...state };
  newState.updateInProgress = false;
  newState.updateError = true;
  newState.updateErrorMessage = action.payload;
  return newState;
}

function createModelRunAssetBegin(state, action) {
  let newState = Object.assign({}, state);
  newState.uploadProgress = { ...state.uploadProgress, [action.payload]: 5 };
  return newState;
}

function resetCompletedUploads(state, action) {
  return {
    ...state,
    completedUploads: [],
  };
}

function createModelRunAssetSuccess(state, action) {
  let newState = JSON.parse(JSON.stringify(state));

  let assetsList = newState.selectedModelRun.assets || [];
  assetsList.push(action.payload.createAssetItem);
  newState.selectedModelRun.assets = [...assetsList];

  // Add the filename to the completedUploads array
  newState.completedUploads = [
    ...newState.completedUploads,
    action.payload.createAssetItem.filename,
  ];
  const newUploadProgress = { ...newState.uploadProgress };
  delete newUploadProgress[action.payload.createAssetItem.filename];
  newState.uploadProgress = newUploadProgress;
  const newCancelTokens = { ...newState.cancelTokens };
  delete newCancelTokens[action.payload.createAssetItem.filename];
  newState.cancelTokens = newCancelTokens;
  return newState;
}
function updateModelRunAssetBegin(state, action) {
  let newState = Object.assign({}, state);
  return newState;
}

function updateModelRunAssetSuccess(state, action) {
  let newState = Object.assign({}, state);
  newState.deleteAssetStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED;
  return newState;
}

function deleteModelRunAssetBegin(state, action) {
  return {
    ...state,
    deleteAssetInProgress: true,
    deleteError: false,
    deleteErrorMessage: ""
  };
}
function deleteModelRunAssetSuccess(state, action) {
  // Deep copying nested structures
  const assetsList = state.selectedModelRun.assets.filter(
    (item) => item.id !== action.payload.deleteAssetItem.id
  );

  return {
    ...state,
    selectedModelRun: {
      ...state.selectedModelRun,
      assets: [...assetsList],    
    },
    deleteAssetInProgress: false,
    deleteError: false,
    deleteErrorMessage: "",
    deleteAssetStatus: GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS
  };
}

function deleteModelRunAssetFailure(state, action) {
  return {
    ...state,
    assets: [],
    deleteAssetStatus: GLOBAL_CONSTANTS.REQUEST_STATUS.FAILURE,
    deleteError: true,
    deleteErrorMessage: action.payload
  };
}
function setUploadProgress(state, action) {
  return {
    ...state,
    uploadProgress: {
      ...state.uploadProgress,
      [action.filename]: action.progress,
    },
  };
}
function addAssetUploadCancelToken(state, action) {
  const newUploadProgress = { ...state.uploadProgress };
  delete newUploadProgress[action.filename];

  return {
    ...state,
    cancelTokens: {
      ...state.cancelTokens,
      [action.filename]: action.cancelToken,
    },
    uploadProgress: newUploadProgress,
  };
}

function removeAssetUploadCancelToken(state, action) {
  const newCancelTokens = { ...state.cancelTokens };
  delete newCancelTokens[action.filename];
  const newCompletedUploads = state.completedUploads.filter(
    (filename) => filename !== action.filename
  );
  const newUploadProgress = { ...state.uploadProgress };
  delete newUploadProgress[action.filename];
  return {
    ...state,
    cancelTokens: newCancelTokens,
    uploadProgress: newUploadProgress,
    completedUploads: newCompletedUploads,
  };
}
function deleteModelRunBegin(state, action) {
  let newState = { ...state };
  newState.deleteModelRunStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.STARTED;
  return newState;
}
function deleteModelRunSuccess(state, action) {
  let newState = { ...state };
  newState.deleteModelRunStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.SUCCESS;

  // Assuming action.payload.id contains the ID to be removed
  newState.modelRuns = newState.modelRuns.filter(
    (modelRun) => modelRun.id !== action.payload.deleteModelRun.id
  );

  return newState;
}

function deleteModelRunFailure(state, action) {
  let newState = { ...state };
  newState.deleteModelRunStatus = GLOBAL_CONSTANTS.REQUEST_STATUS.FAILURE;
  newState.deleteError = true;
  newState.deleteErrorMessage = action.payload;
  return newState;
}

function generateRunBegin(state, action) {
  let newState = { ...state };
  newState.generateInProgress = true;
  newState.generateError = false;
  newState.generateErrorMessage = "";
  newState.selectedModelRun.generateRunStatus =
    GLOBAL_CONSTANTS.GENERATE_STATUS.GENERATE_STARTED;
  return newState;
}

function generateRunSuccess(state, action) {
  // Creating a new object for the entire state
  let newState = { ...state };

  // Checking if 'selectedModelRun' exists and cloning it to maintain immutability
  if (newState.selectedModelRun) {
    newState.selectedModelRun = { ...newState.selectedModelRun };
  } else {
    // If 'selectedModelRun' does not exist, initialize it as an empty object
    newState.selectedModelRun = {};
  }

  // Updating nested properties directly in the new 'selectedModelRun' object
  newState.selectedModelRun.runStatus = action.payload.generateRun.runStatus;
  newState.selectedModelRun.generated = action.payload.generateRun.generated;
  newState.selectedModelRun.generateRunStatus = GLOBAL_CONSTANTS.GENERATE_STATUS.GENERATE_SUCCESS;

  // Marking progress as false in the new state object
  newState.generateInProgress = false;

  // Returning the newly updated state
  return newState;
}


function generateRunFailure(state, action) {
  let newState = { ...state };
  newState.generateInProgress = false;
  newState.generateError = true;
  // Check if payload is a string and contains ':'
  if (typeof action.payload === "string" && action.payload.includes(":")) {
    // Split the string and take the first part
    newState.generateErrorMessage = action.payload.split(":")[0];
  } else {
    // If payload is not a string or doesn't contain ':', use the entire payload
    newState.generateErrorMessage =
      "Error occurred while generating the model run, please check your templates syntax or contact the template provider.";
  }
  newState.selectedModelRun.generateRunStatus =
    GLOBAL_CONSTANTS.GENERATE_STATUS.NONE;
  return newState;
}

function resetSelectedModelRunStatus(state, action) {
  let newState = { ...state };
  newState.selectedModelRun.generateRunStatus =
    GLOBAL_CONSTANTS.GENERATE_STATUS.NONE;
  return newState;
}

function executeModelRunBegin(state, action) {
  let newState = { ...state };
  newState.executeInProgress = true;
  newState.executeError = false;
  newState.executeErrorMessage = "";
  return newState;
}

function executeModelRunSuccess(state, action) {
  let newState = { ...state };
  newState.executeInProgress = false;
  newState.executeSuccess = true;
  let currentItems = [...(newState.tasks || [])]
    
  currentItems.push(action.payload.executeModelRunTask);

  currentItems.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

  newState.tasks = currentItems;

  return newState;
}

function executeModelRunFailure(state, action) {
  let newState = { ...state };
  newState.executeInProgress = false;
  newState.executeError = true;
  newState.executeErrorMessage = action.payload;
  return newState;
}

function fetchModelRunTasksBegin(state, action) {
  let newState = { ...state };
  newState.fetchModelRunTasksInProgress = true;
  newState.fetchModelRunTasksError = false;
  newState.tasks = [];
  newState.fetchModelRunTasksErrorMessage = "";
  newState.tasksNextToken = "";
  return newState;
}

function fetchModelRunTasksSuccess(state, action) {
  let newState = { ...state };
  let newTasks = action.payload.listModelRunTasks?.items || [];
  newState.tasks = newTasks;
  newState.tasksNextToken =action.payload.listModelRunTasks?.nextToken;
  newState.fetchModelRunTasksInProgress = false;
  newState.fetchModelRunTasksError = false;
  newState.fetchModelRunTasksErrorMessage = "";
  return newState;
}

function fetchModelRunTasksFailure(state, action) {
  let newState = { ...state };
  newState.tasks = [];
  newState.tasksNextToken = "";
  newState.fetchModelRunTasksInProgress = false;
  newState.fetchModelRunTasksError = true;
  newState.fetchModelRunTasksErrorMessage = action.payload;
  return newState;
}

// Report Runs Reducers - Unified structure for reporting
function addReportRun(state, action) {
  const reportRun = action.payload;
  const newState = {
    ...state,
    reportRuns: {
      ...state.reportRuns,
      [reportRun.id]: {
        id: reportRun.id,
        name: reportRun.name,
        status: reportRun.status,
        assets: [],
        selectedVtszAssets: [],
        selectedMediaAssets: []
      },
    },
  };
  return newState;
}

function removeReportRun(state, action) {
  const modelRunId = action.payload;
  const newReportRuns = { ...state.reportRuns };
  delete newReportRuns[modelRunId];
  
  const newState = {
    ...state,
    reportRuns: newReportRuns,
  };
  return newState;
}

function updateReportRunSelectedAssets(state, action) {
  const { modelRunId, assetType, selectedAssets } = action.payload;
  
  const newState = {
    ...state,
    reportRuns: {
      ...state.reportRuns,
      [modelRunId]: {
        ...state.reportRuns[modelRunId],
        [assetType]: selectedAssets,
      },
    },
  };
  return newState;
}

function fetchReportModelRunAssetsBegin(state, action) {
  const newState = {
    ...state,
    fetchReportAssetsInProgress: true,
    fetchReportAssetsError: false,
    fetchReportAssetsErrorMessage: "",
  };
  return newState;
}

function fetchReportModelRunAssetsSuccess(state, action) {
  const { modelRunId, listAssetItems } = action.payload;
  const assets = listAssetItems?.items || [];
  
  const newState = {
    ...state,
    fetchReportAssetsInProgress: false,
    fetchReportAssetsError: false,
    fetchReportAssetsErrorMessage: "",
    reportRuns: {
      ...state.reportRuns,
      [modelRunId]: {
        ...state.reportRuns[modelRunId],
        assets: assets,
      },
    },
  };
  return newState;
}

function fetchReportModelRunAssetsFailure(state, action) {
  const newState = {
    ...state,
    fetchReportAssetsInProgress: false,
    fetchReportAssetsError: true,
    fetchReportAssetsErrorMessage: action.payload,
  };
  return newState;
}

function fetchModelRunAssetsBegin(state, action) {
  const newState = {
    ...state,
    fetchModelRunAssetsInProgress: true,
    fetchModelRunAssetsError: false,
    fetchModelRunAssetsErrorMessage: "",
    selectedModelRun: {
      ...state.selectedModelRun,
      assets: [], // reset to empty list
    },
  };
  return newState;
}

function fetchModelRunAssetsSuccess(state, action) {
  const newState = {
    ...state,
    fetchModelRunAssetsInProgress: false,
    fetchModelRunAssetsError: false,
    fetchModelRunAssetsErrorMessage: "",
    selectedModelRun: {
      ...state.selectedModelRun,
      assets: action.payload.listAssetItems?.items || [],        
    },
  };
  return newState;
}

function fetchModelRunAssetsFailure(state, action) {
  const newState = {
    ...state,
    fetchModelRunAssetsInProgress: false,
    fetchModelRunAssetsError: true,
    fetchModelRunAssetsErrorMessage: action.payload,
    selectedModelRun: {
      ...state.selectedModelRun,
      assets: [], // clear the list on failure
    },
  };
  return newState;
}



function terminateModelRunTaskBegin(state, action) {
  let newState = { ...state };
  newState.terminateInProgress = true;
  newState.terminateError = false;
  newState.terminateErrorMessage = "";
  return newState;
}

function terminateModelRunTaskSuccess(state, action) {
  let newState = { ...state };
  newState.terminateInProgress = false;
  newState.terminateSuccess = true;
  let currentItems = [...(newState.selectedModelRun.tasks || [])]
  let updatedItems = currentItems.map((item) => {
    if (item.id === action.payload.terminateModelRunTask.id) {
      return action.payload.terminateModelRunTask;
    }
    return item;
  }
  );
  updatedItems.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  newState.selectedModelRun.tasks = updatedItems;
  return newState;
}

function terminateModelRunTaskFailure(state, action) {
  let newState = { ...state };
  newState.terminateInProgress = false;
  newState.terminateError = true;
  newState.terminateErrorMessage = action.payload;
  return newState;
}

function executePostProcessingBegin(state, action) {
  let newState = { ...state };
  newState.executePostProcessingInProgress = true;
  newState.executePostProcessingError = false;
  newState.executePostProcessingErrorMessage = "";
  newState.executePostProcessOverview = {
    logs: [],
    status: "",
    result: "",
    completedSteps: [],
    finished: false,

  };
  return newState;
}

function executePostProcessingSuccess(state, action) {
  const newState = { ...state };
  newState.executePostProcessingInProgress = false;
  newState.executePostProcessingSuccess = true;
  newState.executePostProcessingError = false;
  newState.executePostProcessingErrorMessage = '';

  const overview = action.payload.executePostProcess || {};
  
  // Parse each log entry if it's a JSON string
  const parsedLogs = (overview.logs || []).map(tryParseJson);
  
  // Parse status and result if they’re JSON strings
  const parsedStatus = tryParseJson(overview.status || '');
  const parsedResult = tryParseJson(overview.result || '');
  // Extract completed steps from parsedStatus.details
  const newCompletedSteps = parsedStatus?.details ? parsedStatus.details.split(',').map(item => item.trim()) : [];

  newState.executePostProcessOverview = {
    operationId: overview.operationId,
    logs: parsedLogs,
    status: parsedStatus,
    result: parsedResult,
    completedSteps: newCompletedSteps,
    finished: false,
  };


  return newState;
}

function getPostProcessOperationOverviewSuccess(state, action) {
  const newState = { ...state };

  const overview = action.payload.getOperationOverview || {};
  
  // Parse each log entry if it's a JSON string
  const parsedLogs = (overview.logs || []).map(tryParseJson);
  
  // Parse status and result if they’re JSON strings
  const parsedStatus = tryParseJson(overview.status || '');
  const parsedResult = tryParseJson(overview.result || '');
  const newCompletedSteps = parsedStatus?.details ? parsedStatus.details.split(',').map(item => item.trim()) : [];


  newState.executePostProcessOverview = {
    operationId: overview.operationId,
    logs: parsedLogs,
    status: parsedStatus,
    result: parsedResult,
    completedSteps: newCompletedSteps,
    finished: parsedStatus?.status === 'COMPLETED',
  };

  return newState;
}

function getPostProcessOperationOverviewFailure(state, action) {
  const newState = { ...state };

  return newState;
}

function getPostProcessOperationOverviewBegin(state, action) {
  const newState = { ...state };

  return newState;
}

export const modelRunReducers = createReducer(modelrunInitialState, {
  SET_ACTIVE_MODELRUN_ACTION: setselectedModelRun,
  FETCH_MODELRUNS_SUCCESS_ACTION: fetchModelRunsSuccess,
  FETCH_MODELRUNS_BEGIN_ACTION: fetchModelRunsBegin,
  FETCH_MODELRUNS_FAILURE_ACTION: fetchModelRunsFailure,
  FETCH_MODELRUN_BY_ID_BEGIN_ACTION: fetchModelRunByIdBegin,
  FETCH_MODELRUN_BY_ID_SUCCESS_ACTION: fetchModelRunByIdSuccess,
  FETCH_MODELRUN_BY_ID_FAILURE_ACTION: fetchModelRunByIdFailure,
  CREATE_NEW_MODELRUN_BEGIN_ACTION: createNewModelRunBegin,
  CREATE_NEW_MODELRUN_SUCCESS_ACTION: createNewModelRunSuccess,
  CREATE_NEW_MODELRUN_FAILURE_ACTION: createNewModelRunFailure,
  UPDATE_MODELRUN_BEGIN_ACTION: updateModelRunBegin,
  UPDATE_MODELRUN_SUCCESS_ACTION: updateModelRunSuccess,
  UPDATE_MODELRUN_FAILURE_ACTION: updateModelRunFailure,
  UPDATE_ACTIVE_MODELRUN_ACTION: updateselectedModelRun,
  CREATE_MODELRUN_ASSET_BEGIN_ACTION: createModelRunAssetBegin,
  CREATE_MODELRUN_ASSET_SUCCESS_ACTION: createModelRunAssetSuccess,
  UPDATE_MODELRUN_ASSET_SUCCESS_ACTION: updateModelRunAssetSuccess,
  UPDATE_MODELRUN_ASSET_BEGIN_ACTION: updateModelRunAssetBegin,
  DELETE_MODELRUN_ASSET_BEGIN_ACTION: deleteModelRunAssetBegin,
  DELETE_MODELRUN_ASSET_SUCCESS_ACTION: deleteModelRunAssetSuccess,
  DELETE_MODELRUN_ASSET_FAILURE_ACTION: deleteModelRunAssetFailure,
  SET_ASSET_UPLOAD_PROGRESS_ACTION: setUploadProgress,
  ADD_ASSET_UPLOAD_CANCEL_TOKEN: addAssetUploadCancelToken,
  REMOVE_ASSET_UPLOAD_CANCEL_TOKEN: removeAssetUploadCancelToken,
  DELETE_MODELRUN_BEGIN_ACTION: deleteModelRunBegin,
  DELETE_MODELRUN_SUCCESS_ACTION: deleteModelRunSuccess,
  DELETE_MODELRUN_FAILURE_ACTION: deleteModelRunFailure,
  RESET_COMPLETED_UPLOADS_ACTION: resetCompletedUploads,
  GENERATE_RUN_BEGIN_ACTION: generateRunBegin,
  GENERATE_RUN_SUCCESS_ACTION: generateRunSuccess,
  GENERATE_RUN_FAILURE_ACTION: generateRunFailure,
  RESET_MODELRUN_STATE_ACTION: resetModelRunState,
  RESET_SELECTED_MODELRUN_STATUS_ACTION: resetSelectedModelRunStatus,
  UPDATE_MODELRUN_PROPS_SUCCESS_ACTION: updateModelRunPropsSuccess,
  EXECUTE_MODELRUN_BEGIN_ACTION: executeModelRunBegin,
  EXECUTE_MODELRUN_SUCCESS_ACTION: executeModelRunSuccess,
  EXECUTE_MODELRUN_FAILURE_ACTION: executeModelRunFailure,
  FETCH_MODELRUN_TASKS_BEGIN_ACTION: fetchModelRunTasksBegin,
  FETCH_MODELRUN_TASKS_SUCCESS_ACTION: fetchModelRunTasksSuccess,
  FETCH_MODELRUN_TASKS_FAILURE_ACTION: fetchModelRunTasksFailure,
  TERMINATE_MODELRUN_TASK_BEGIN_ACTION: terminateModelRunTaskBegin,
  TERMINATE_MODELRUN_TASK_SUCCESS_ACTION: terminateModelRunTaskSuccess,
  TERMINATE_MODELRUN_TASK_FAILURE_ACTION: terminateModelRunTaskFailure,
  FETCH_MODELRUN_ASSETS_BEGIN_ACTION: fetchModelRunAssetsBegin,
  FETCH_MODELRUN_ASSETS_SUCCESS_ACTION: fetchModelRunAssetsSuccess,
  FETCH_MODELRUN_ASSETS_FAILURE_ACTION: fetchModelRunAssetsFailure,
  EXECUTE_POST_PROCESSING_BEGIN_ACTION: executePostProcessingBegin,
  EXECUTE_POST_PROCESSING_SUCCESS_ACTION: executePostProcessingSuccess,
  EXECUTE_POST_PROCESSING_FAILURE_ACTION: executeModelRunFailure,
  GET_POSTPROCESSING_OPERATION_OVERVIEW_BEGIN_ACTION: getPostProcessOperationOverviewBegin,
  GET_POSTPROCESSING_OPERATION_OVERVIEW_SUCCESS_ACTION: getPostProcessOperationOverviewSuccess,
  GET_POSTPROCESSING_OPERATION_OVERVIEW_FAILURE_ACTION: getPostProcessOperationOverviewFailure,
  ADD_REPORT_RUN_ACTION: addReportRun,
  REMOVE_REPORT_RUN_ACTION: removeReportRun,
  UPDATE_REPORT_RUN_SELECTED_ASSETS_ACTION: updateReportRunSelectedAssets,
  FETCH_REPORT_MODELRUN_ASSETS_BEGIN_ACTION: fetchReportModelRunAssetsBegin,
  FETCH_REPORT_MODELRUN_ASSETS_SUCCESS_ACTION: fetchReportModelRunAssetsSuccess,
  FETCH_REPORT_MODELRUN_ASSETS_FAILURE_ACTION: fetchReportModelRunAssetsFailure,
});
